const KeyWordList = [
 "Python",
 "JavaScript",
 "Ruby",
 "PHP",
 "Rails",
 "iOS",
 "AWS",
 "Android",
 "Java",
 "Swift",
 "Docker",
 "Linux",
 "Node.js",
 "Git",
 "Mac",
 "Unity",
 "Csharp",
 "Python3",
 "MySQL",
 "Go",
 "C++",
 "CSS",
 "Windows",
 "機械学習",
 "Xcode",
 "初心者",
 "HTML",
 "Ubuntu",
 "CentOS",
 "GitHub",
 "RaspberryPi",
 "Laravel",
 "Objective-C",
 "Vagrant",
 "Vue.js",
 "jQuery",
 "Bash",
 "Vim",
 "DeepLearning",
 "React",
 "TypeScript",
 "WordPress",
 "golang",
 "Scala",
 "R",
 "MacOSX",
 "HTML5",
 "C",
 "Kotlin",
 "RubyOnRails",
 "nginx",
 "Slack",
 "Heroku",
 "TensorFlow",
 "PostgreSQL",
 "ShellScript",
 "centos7",
 "lambda",
 "Azure",
 "SQL",
 "IoT",
 "Ansible",
 "Django",
 "Apache",
 "kubernetes",
 "MachineLearning",
 "Windows10",
 "SSH",
 "iPhone",
 "VirtualBox",
 "Firebase",
 "Haskell",
 "Arduino",
 "Excel",
 "Emacs",
 "OpenCV",
 "新人プログラマ応援",
 "EC2",
 "AndroidStudio",
 "Chrome",
 "PowerShell",
 "GoogleAppsScript",
 "reactjs",
 "VSCode",
 "api",
 "Qiita",
 "Elixir",
 "ポエム",
 "JSON",
 "homebrew",
 "docker-compose",
 "数学",
 "Twitter",
 "Perl",
 "GoogleCloudPlatform",
 "npm",
 "oracle",
 "shell",
 "AngularJS",
 "webpack",
 "babel"
]

export default{
    KeyWordList
}